module.exports = __webpack_public_path__ + "static/media/marc.0264130a.jpg";